module.exports = __webpack_public_path__ + "static/media/reply.6c5b0d09.svg";